import { render, staticRenderFns } from "./similarAds.vue?vue&type=template&id=79e435f5"
import script from "./similarAds.vue?vue&type=script&lang=js"
export * from "./similarAds.vue?vue&type=script&lang=js"
import style0 from "./similarAds.vue?vue&type=style&index=0&id=79e435f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports